 import MyItemCard from "./MyItemCard";

function ItemGrid({ items, type }) {
  return (
    <div className="container-fluid">
      <div className="row g-2 mt-3">
        {items.map((item) => (
          <div
            key={item._id}
            className="col-lg-2 col-md-3 col-sm-4 col-6 d-flex justify-content-center"
          >
            <MyItemCard item={item} type={type} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ItemGrid;
